import type { InvoiceType } from "./invoiceDocumentTypes";

export function keyForInvoiceType(t: InvoiceType): "orders" | "installation" | "removal" {
  return t === "sales" ? "orders" : t;
}

export function invoiceTitleWords(isSales: boolean, isInstall: boolean): string[] {
  if (isSales) return ["Sales", "Invoice"];
  if (isInstall) return ["Installation", "Job", "Invoice"];
  return ["Removal", "Job", "Invoice"];
}
